module.exports = __webpack_public_path__ + "static/media/full-star.9e8af3de.svg";